
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Testimonials = () => {
  const testimonialData = [
    {
      title: "Our Testament of Service Well-Served",
      quote: "Working with CFO Bridge has been the best investment for GOQii. Their strategic financial insights, robust modeling, and partnership-driven approach unlocked unseen opportunities. They seamlessly scaled with our needs, becoming an integral part of our core team.",
      name: "Vishal Gondal",
      designation: "Founder & CEO - GOQii",
      image: "https://cfobridge.com/uploads/images/vishal_gondal.webp",
      quoteIcon: "https://md-aqil.github.io/images/quote.png",
      ctaText: "Know More",
      ctaLink: "/testimonials"
    },
    {
      title: "Our Testament of Service Well-Served",
      quote: "Working with CFO Bridge has been transformative. Their expertise in financial modeling, accurate data handling, and strategic insights has driven our growth. A reliable partner for over 7 years, delivering consistent value.",
      name: "Akhilesh Bhargava",
      designation: "MD - AVI Global Plast",
      image: "https://cfobridge.com/uploads/images/akhilesh_bhargava.webp",
      quoteIcon: "https://md-aqil.github.io/images/quote.png",
      ctaText: "Know More",
      ctaLink: "/testimonials"
    },
    {
      title: "Our Testament of Service Well-Served",
      quote: "CFO Bridge has been instrumental in scaling our finance practices. Their expertise in cash flow, working capital, and strategic planning helped us achieve 30-35% growth. Their flexible partnership model is a game-changer.",
      name: "Siddhi Milap Shah",
      designation: "Owner & Founder - PrintStop",
      image: "https://cfobridge.com/uploads/images/siddhi_milap_shah.webp",
      quoteIcon: "https://md-aqil.github.io/images/quote.png",
      ctaText: "Know More",
      ctaLink: "/testimonials"
    },
    {
      title: "Our Testament of Service Well-Served",
      quote: "Working with CFO Bridge for two years has been fantastic. Their team Srini, Shilpa, and Hitesh has been incredibly supportive. I highly recommend them, especially for startups needing top-quality CFO expertise without the full-time cost. Great work!",
      name: "Mahesh Bhupathi",
      designation: "Co-Founder - Scentials Beauty & Social Swag",
      image: "https://cfobridge.com/uploads/images/mahesh-bhupathi.webp",
      quoteIcon: "https://md-aqil.github.io/images/quote.png",
      ctaText: "Know More",
      ctaLink: "/testimonials"
    },
    {
      title: "Our Testament of Service Well-Served",
      quote: "CFO Bridge helped us create compliant inter-company policies and optimize local financial processes. They exceeded expectations and made the collaboration enjoyable. Highly recommend their expertise!",
      name: "Janos Vaczi",
      designation: "CEO & MD - Extrovis",
      image: "https://cfobridge.com/uploads/images/janos_vaczi.webp",
      quoteIcon: "https://md-aqil.github.io/images/quote.png",
      ctaText: "Know More",
      ctaLink: "/testimonials"
    },
    {
      title: "Our Testament of Service Well-Served",
      quote: "CFO Bridge has been a trusted partner for 3-4 years. Their team, especially Hitesh, helped us build a strong MIS process and provided invaluable insights for growth decisions. Highly recommend their expertise!",
      name: "Gautam Rajani",
      designation: "CEO & Founder - TM Printers",
      image: "https://cfobridge.com/uploads/images/gautam_rajani.webp",
      quoteIcon: "https://md-aqil.github.io/images/quote.png",
      ctaText: "Know More",
      ctaLink: "/testimonials"
    }
  ];

  // Slick slider settings
  const sliderSettings = {
    infinite: true,
    speed: 800,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    pauseOnFocus: true,
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };

  // Generate initials from name for avatar fallback
  const getInitials = (name) => {
    return name.split(' ').map(word => word[0]).join('').toUpperCase();
  };
  const sectionStyle = {
    background: `
      linear-gradient(135deg, rgba(1, 66, 147, 0.85) 0%, rgba(15, 52, 96, 0.85) 50%, rgba(30, 74, 115, 0.85) 100%) center center / cover fixed, url('./images/team_bg.webp')
    `,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed'
  };

  return (
    <section className="testimonials-section-wireframe" id="testimonials" style={sectionStyle}>
      <div className="testimonials-container-wireframe">
        <div className="testimonials-header-wireframe">
          <h2 className="testimonials-title-wireframe">Our Testament of Service Well-Served</h2>
        </div>

        <div className="testimonials-slider-wireframe">
          <Slider {...sliderSettings}>
            {testimonialData.map((testimonial, index) => (
              <div key={index} className="testimonial-slide-item-wireframe">
                <div className="testimonial-card-wireframe">
                  {/* Header with photo and info side by side */}
                  <div className="testimonial-header-wireframe">
                    <div className="testimonial-avatar-container-wireframe">
                      <img
                        src={testimonial.image}
                        alt={testimonial.name}
                        className="testimonial-avatar-wireframe"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.nextSibling.style.display = 'flex';
                        }}
                      />
                      <div className="testimonial-avatar-placeholder-wireframe" style={{ display: 'none' }}>
                        <span>{getInitials(testimonial.name)}</span>
                      </div>
                    </div>
                    <div className="testimonial-info-wireframe">
                      <h4 className="testimonial-name-wireframe">{testimonial.name}</h4>
                      <p className="testimonial-designation-wireframe">{testimonial.designation}</p>
                    </div>
                  </div>

                  {/* Content below spanning full width */}
                  <div className="testimonial-content-wireframe">
                    <p className="testimonial-text-wireframe">"{testimonial.quote}"</p>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
        {/* CTA Button */}
        <div className="team-cta-container">
          <a
            href="https://cfobridge.com/testimonials"
            target="_blank"
            rel="noopener noreferrer"
            className="team-cta-button"
          >
            View All Testimonials
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="team-cta-icon"
            >
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </a>
        </div>
      </div>

    </section>
  );
};

export default Testimonials; 